import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const preview = document.querySelector("#shipping-preview .alert")
    if (preview) {
      const msg = preview.innerText.trim()
      if (!confirm(msg + "\n\nConfirmer ?")) {
        event.preventDefault()
      }
    }
  }
}
